import { Reveal } from "../Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLang } from "../../context/LanguageContext";

export function FAQSection({ faq = [] }) {
  const { t } = useLang();
  if (!faq.length) return null;
  return (
    <section data-testid="course-faq" className="bg-[#E9EFFA] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[900px] mx-auto">
        <Reveal className="mb-12 text-center">
          <span className="overline">{t("faq.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3">
            {t("faq.title")}
          </h2>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {faq.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#D5DEEE]" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-6 text-left hover:no-underline group">
                  <span className="text-lg md:text-xl font-medium text-[#0B1220] group-hover:text-[#1452F0] transition-colors pr-4">
                    {item.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6">
                  <p className="text-[#5C6678] font-light leading-relaxed text-base">{item.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
